<span header-title>
  {{ 'cards.lexi_market_settings.product_fields_settings.title' | translate }}
</span>